import { money } from '../../../utils';

// Column definitions for the on-demand "JLOC Detail" CSV export (CP-828, revised CP-839).
// CP-839: the export mirrors the on-screen AR Aging Report columns EXACTLY — same headers,
// order, and money formatting as arAgingColumns in ARAgingReportTable.js — with the Job
// Location columns appended at the end. Nothing else (no Company/AMC/SPC/Future columns).
// Sourced from sp_cl_cp_bi_ara_detail (report name `aging-report-detail`), which explodes
// each invoice's balance across its job locations. Accessors MUST match the proc's output
// column names exactly (note the source spellings Aging_Nighty / Aging_Over_Nighty) or the
// column exports blank. This dataset is export-only — there is no on-screen table for it.
export const arAgingDetailColumns = [
  // Existing AR Aging Report format (mirror of arAgingColumns — keep the two in sync)
  { Header: 'Bill To#', accessor: 'BillToNumber' },
  { Header: 'Bill To Name', accessor: 'BillToName' },
  { Header: 'Invoice #', accessor: 'Invoice_Number' },
  { Header: 'Trans Date', accessor: 'Trans_Date' },
  { Header: 'Trans Code', accessor: 'Trans_Code' },
  {
    Header: 'Transaction Amount',
    accessor: 'Trans_Amount',
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'Transaction Balance',
    accessor: 'Trans_Balance',
    Cell: instance => money.format(instance.value),
  },
  { Header: '0-30', accessor: 'Aging_Thirty' },
  { Header: '31-60', accessor: 'Aging_Sixty' },
  { Header: '61-90', accessor: 'Aging_Nighty' },
  { Header: 'Over 90', accessor: 'Aging_Over_Nighty' },
  { Header: 'Future Cash On Account', accessor: 'Future_Cash_On_Account' },
  { Header: 'Less Cash On Account', accessor: 'Less_Cash_On_Account' },
  {
    Header: 'Account Balance',
    accessor: 'Account_Balance',
    Cell: instance => money.format(instance.value),
  },
  { Header: 'CR Limit', accessor: 'Credit_Limit' },
  { Header: 'Last Pay', accessor: 'Last_Pay' },
  { Header: 'LOB', accessor: 'LOB' },
  { Header: 'Branch', accessor: 'Branch' },
  { Header: 'Job Branch', accessor: 'JobBranch' },

  // Job Location values appended to the end (the purpose of the detail variant)
  { Header: 'Job Id', accessor: 'Job_Id' },
  { Header: 'Job Location Name', accessor: 'Job_Location_Name' },
  { Header: 'Job Location Address 1', accessor: 'Job_Location_Address1' },
  { Header: 'Job Location Address 2', accessor: 'Job_Location_Address2' },
  { Header: 'Job Location City', accessor: 'Job_Location_City' },
  { Header: 'Job Location State', accessor: 'Job_Location_State' },
  { Header: 'Job Location Zip', accessor: 'Job_Location_Zip' },
  { Header: 'Job Billed Amount', accessor: 'Job_Billed_Amount' },
  { Header: 'Allocation %', accessor: 'Alloc_Pct' },
];

export default arAgingDetailColumns;
